import React from "react";
import { CreditAssessmentResult } from "./types";
const Success = ({ retailerName, retailerPhoneNumber, financialProvider, }) => (React.createElement("div", { "data-ecom-alert": "success" },
    React.createElement("div", { className: "alert-icon-section" },
        React.createElement("div", { className: "alert-icon" },
            React.createElement("i", { className: "icon-check no-margin" }))),
    React.createElement("div", { className: "alert-content" },
        React.createElement("p", null,
            React.createElement("span", { className: "font-medium" },
                "Grattis! Din l\u00E5neans\u00F6kan har beviljats av",
                " ",
                financialProvider,
                "."),
            " "),
        "Bilen \u00E4r inte reserverad \u00E4nnu. Slutf\u00F6r ordern genom att klicka dig igenom n\u00E4stkommande steg. Har du fr\u00E5gor under tiden? Kontakta",
        " ",
        retailerName,
        " p\u00E5 tel ",
        retailerPhoneNumber,
        ".")));
const Failure = ({ retailerName, retailerPhoneNumber }) => (React.createElement("div", { "data-ecom-alert": "error" },
    React.createElement("div", { className: "alert-icon-section" },
        React.createElement("div", { className: "alert-icon" },
            React.createElement("i", { className: "icon-exclamation no-margin" }))),
    React.createElement("div", { className: "alert-content" },
        React.createElement("p", null,
            React.createElement("span", { className: "font-medium" }, "Vi kan tyv\u00E4rr inte bevilja din ans\u00F6kan om bill\u00E5n."),
            " "),
        React.createElement("p", null, "Det kan finnas olika sk\u00E4l till att en ans\u00F6kan nekas. Du kommer inom kort f\u00E5 ett brev med bekr\u00E4ftelse och mer information om just din ans\u00F6kan."),
        React.createElement("p", null, "Ditt redan p\u00E5b\u00F6rjade k\u00F6p kan fortfarande genomf\u00F6ras och avslutas, f\u00F6r att g\u00E5 vidare kan du v\u00E4lja ett annat betals\u00E4tt."),
        "Har du fr\u00E5gor under tiden? Kontakta ",
        retailerName,
        " p\u00E5 tel",
        " ",
        retailerPhoneNumber,
        ".")));
const AssessManually = ({ retailerName, retailerPhoneNumber, }) => (React.createElement("div", { "data-ecom-alert": "warning" },
    React.createElement("div", { className: "alert-icon-section" },
        React.createElement("div", { className: "alert-icon" },
            React.createElement("i", { className: "icon-exclamation no-margin" }))),
    React.createElement("div", { className: "alert-content" },
        React.createElement("p", null,
            React.createElement("span", { className: "font-medium" }, "N\u00E4r ordern \u00E4r slutf\u00F6rd kommer vi att g\u00E5 igenom ditt \u00E4rende och \u00E5terkoppla till dig med ett l\u00E5nebesked.")),
        "Din bil \u00E4r fortfarande inte reserverad. G\u00E5 vidare till n\u00E4sta steg f\u00F6r att slutf\u00F6ra ordern, men det \u00E4r inte s\u00E4kert att ditt l\u00E5n kommer att beviljas. Har du fr\u00E5gor under tiden? Kontakta ",
        retailerName,
        " p\u00E5 tel ",
        retailerPhoneNumber,
        ".")));
const Result = ({ result, retailerName, retailerPhoneNumber, financialProvider, }) => {
    switch (result) {
        case CreditAssessmentResult.Approve:
            return (React.createElement(Success, { retailerName: retailerName, retailerPhoneNumber: retailerPhoneNumber, financialProvider: financialProvider }));
        case CreditAssessmentResult.Reject:
            return (React.createElement(Failure, { retailerName: retailerName, retailerPhoneNumber: retailerPhoneNumber, financialProvider: financialProvider }));
        default:
            return (React.createElement(AssessManually, { retailerName: retailerName, retailerPhoneNumber: retailerPhoneNumber, financialProvider: financialProvider }));
    }
};
export default Result;
